import * as React from 'react'
import {
  aboutTag,
  contactMail,
  contactUs,
  mobileStores,
  ourProducts,
  paymentMethods,
  tagAddress,
  termsAndPolicy
} from './defaultData'
import BottomFooter from './BottomFooter'
import TopFooter from './TopFooter'
import styled from 'styled-components'


const FooterWrapper = styled.footer`
  background-color: #f9f9f9;
  padding: 35px 0px;

  font-family: 'Noto Sans', sans-serif;

  & a,
  & h3 {
    color:#53586F;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Noto Sans', sans-serif;
  }

  @media only screen and (min-width: 992px) {
    padding-top: 57px;
    padding-bottom: 14px;
  }
`

const CenteredContainer = styled.div`
  margin: 0 auto;
  max-width: 1172px;
`

const Footer = () => {
  return (
    <FooterWrapper>
      <CenteredContainer>
        <TopFooter { ...{ aboutTag, contactMail, contactUs, mobileStores, ourProducts, paymentMethods } } />
        <hr />
        <BottomFooter { ...{ ...tagAddress, termsAndPolicy } } />
      </CenteredContainer>
    </FooterWrapper>
  )
}

export default Footer
